import { DAPI_HOST } from '../../../../../config';
import { ORIGIN_REACT_MOBILE_APP } from '../../../../../constants';
import { apiGetJson } from '../../../../../core/dapi';
import { convertSnakeToCamelCase } from '../../../../../core/util/object';

export const fetchSlotsForDate = async (location, selectedDate) => {
  const data = await apiGetJson(
    `${DAPI_HOST}/v1/locations/${location.id}/slots?on_date=${selectedDate.format(
      'YYYY-MM-DD'
    )}&origin=${ORIGIN_REACT_MOBILE_APP}`
  );
  return data.data.map(convertSnakeToCamelCase);
};
